import { useEffect, useState } from "react";
import "./product.css";
import { FaStar, FaStarHalfAlt, FaRegStar, FaCartPlus } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Nav from "../components/Nav";
import { Helmet } from "react-helmet-async";
import API_BASE from "../api/api";

const BookDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // ✅ added

  const [book, setBook] = useState(null);
  const [images, setImages] = useState([]);
  const [mainImage, setMainImage] = useState("");
  const [current, setCurrent] = useState(0);
  const [zoomOpen, setZoomOpen] = useState(false);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [touchStartX, setTouchStartX] = useState(null);

useEffect(() => {
  fetch(`${API_BASE}/getbook.php?id=${id}`)
    .then((res) => res.json())
    .then((data) => {
      console.log("BOOK DETAIL:", data);

      if (data.status === "success") {
        const bookData = data.data;

        setBook(bookData);

        // 🔥 BASE URL
        const BASE_URL = API_BASE.replace("/api", "");

        // 🔥 MAIN IMAGE
        const main = bookData.image
          ? `${BASE_URL}/${String(bookData.image).replace("../", "")}`
          : "";

        // 🔥 SUB IMAGES (FINAL FIX - ARRAY HANDLE)
        const subs = (bookData.sub_images || []).map((img) =>
          `${BASE_URL}/${String(img).replace("../", "")}`
        );

        // 🔥 ALL IMAGES
        const allImages = [main, ...subs].filter(Boolean);

        console.log("IMAGES:", allImages);

        setImages(allImages);
        setMainImage(allImages[0] || "");
        setCurrent(0);
      } else {
        console.error("❌ API error:", data.message);
      }
    })
    .catch((err) => console.error("❌ Fetch error:", err));
}, [id]);
  // ---------- Add to cart ----------
const handleAddToCart = async () => {
  const role = localStorage.getItem("role");

  if (role !== "user") {
    alert("Please login first");
    navigate("/login", {
      state: { from: location.pathname },
    });
    return;
  }

  try {
    const res = await fetch(`${API_BASE}/addcart.php`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        product_id: book.id,
        quantity: 1,
      }),
    });

    const data = await res.json();

    if (data.success) {
      alert("✅ Book added to cart");
      window.dispatchEvent(new Event("cartUpdated"));
      navigate("/cart"); // ✅ redirect
    } else {
      alert("❌ " + data.message);
    }
  } catch (err) {
    console.error(err);
    alert("❌ Network error");
  }
};

  // ---------- SEO helpers ----------
  const site = "https://sangitshreeprakashan.com";
  const canonicalUrl = `${site}/book/${id}`;
  const metaTitle = book
    ? `${book.title} | Buy Online | Sangit Shree Prakashan`
    : "Book | Sangit Shree Prakashan";
  const metaDesc = book?.description
    ? String(book.description).replace(/\s+/g, " ").slice(0, 155)
    : "Buy books from Sangit Shree Prakashan.";
  const ogImage = images?.[0] || `${site}/og-default.jpg`;

  // Helmet render पहले से data आए तब ही
  const SeoHead = book ? (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDesc} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Twitter */}
      <meta property="og:type" content="product" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD Book schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Book",
          name: book.title,
          inLanguage: "hi",
          image: ogImage,
          url: canonicalUrl,
          publisher: {
            "@type": "Organization",
            name: "Sangit Shree Prakashan",
            url: site,
          },
          offers: {
            "@type": "Offer",
            priceCurrency: "INR",
            price: String(book.price ?? ""),
            availability: "https://schema.org/InStock",
            url: canonicalUrl,
            seller: {
              "@type": "Organization",
              name: "Sangit Shree Prakashan",
            },
          },
        })}
      </script>

      {/* Breadcrumbs */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: `${site}/` },
            {
              "@type": "ListItem",
              position: 2,
              name: "Books",
              item: `${site}/books`,
            },
            {
              "@type": "ListItem",
              position: 3,
              name: book.title,
              item: canonicalUrl,
            },
          ],
        })}
      </script>
    </Helmet>
  ) : null;

  if (!book || images.length === 0) {
    // Minimal head while loading
    return (
      <>
        <Helmet>
          <title>Loading… | Sangit Shree Prakashan</title>
          <link rel="canonical" href={canonicalUrl} />
          <meta name="robots" content="noindex" />
        </Helmet>
        <p>Loading book details...</p>
      </>
    );
  }

  const displayThumbs = images.slice(0, 5);
  const extraCount = images.length - 5;

  const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;

    if (diff > 50 && current < images.length - 1) {
      setCurrent(current + 1);
      setMainImage(images[current + 1]);
    } else if (diff < -50 && current > 0) {
      setCurrent(current - 1);
      setMainImage(images[current - 1]);
    }
    setTouchStartX(null);
  };

  return (
    <>
      {SeoHead}

      <Nav />
      <Navbar />

      <div className="book-detail-page">
        <div className="book-detail-wrapper">
          {/* Image Section */}
          <div className="sub_book">
            <div className="book-desktop">
              <div className="thumbs">
                {displayThumbs.map((img, idx) => (
                  <div key={idx} className="thumb-wrapper">
                    <img
                      src={img}
                      alt={`thumb-${idx}`}
                      className={`thumb ${mainImage === img ? "active" : ""}`}
                      onClick={() => {
                        setMainImage(img);
                        setCurrent(idx);
                      }}
                    />
                    {idx === 4 && extraCount > 0 && (
                      <div
                        className="thumb-overlay"
                        onClick={() => setGalleryOpen(true)}
                      >
                        +{extraCount}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div
                className="main-book-img"
                onClick={() => setZoomOpen(true)}
              >
                <img src={mainImage} alt="main" />
              </div>
            </div>

            {/* Mobile Slider */}
            <div
              className="book-mobile"
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              <div className="slider-container">
                <div className="slider">
                  <img src={images[current]} alt={`book-${current}`} />
                </div>
                <div className="slider-dots">
                  {images.map((_, i) => (
                    <span
                      key={i}
                      className={`dot ${i === current ? "active" : ""}`}
                      onClick={() => {
                        setCurrent(i);
                        setMainImage(images[i]);
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Book Info */}
          <div className="book-right">
            <h2 className="book-title">{book.title}</h2>
            <p className="author">
              by <strong>Sangit Shree Prakashan</strong>
            </p>

            <div className="rating">
              <span className="stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStarHalfAlt />
                <FaRegStar />
              </span>
              <span className="review-count">123 ratings & 45 reviews</span>
            </div>

            <div className="price-block">
              <span className="price">₹{book.price}</span>
              {book.mrp && (
                <>
                  <span className="mrp">₹{book.mrp}</span>
                  <span className="discount">
                    {100 - Math.floor((book.price / book.mrp) * 100)}% off
                  </span>
                </>
              )}
            </div>

            <div className="buttons">
              <button className="btn cart" onClick={handleAddToCart}>
                <FaCartPlus /> Add to Cart
              </button>
            </div>

            {book.highlights && (
              <div className="highlights">
                <h4>Highlights</h4>
                <ul>
                  {book.highlights
                    .split("|")
                    .map((h, i) => (
                      <li key={i}>{h}</li>
                    ))}
                </ul>
              </div>
            )}

            {book.description && (
              <div className="desc">
                <h4>Description</h4>
                <p className="book-desc">{book.description}</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />

      {/* Zoom Modal */}
      {zoomOpen && (
        <div className="zoom-modal" onClick={() => setZoomOpen(false)}>
          <div className="zoom-content" onClick={(e) => e.stopPropagation()}>
            <img src={mainImage} alt="zoomed" />
          </div>
        </div>
      )}

      {/* Full Gallery Modal */}
      {galleryOpen && (
        <div className="gallery-modal" onClick={() => setGalleryOpen(false)}>
          <div
            className="gallery-content"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>{book.title}</h3>
            <div className="gallery-preview">
              <img src={images[current]} alt="preview" />
            </div>
            <div className="gallery-grid">
              {images.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`gallery-${idx}`}
                  className={current === idx ? "active-thumb" : ""}
                  onClick={() => {
                    setMainImage(img);
                    setCurrent(idx);
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BookDetails;
